export default "__VITE_ASSET__B9t2Hl8B__"